import styled, { css } from "styled-components";
import { buildColor } from "@tvg/design-system";

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 32px;
  border-radius: 16px;
  background-color: ${buildColor("white", "100")};
`;

export const FilledStarContainer = styled.div`
  position: absolute;
  top: 14px;
  left: 14px;
  height: 5px;
  width: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const IconButtonContainer = styled.div<{ isFavorite: boolean }>`
  svg {
    path {
      transition: fill 0.2s ease-in-out, stroke 0.2s ease-in-out;
      ${({ isFavorite }) =>
        isFavorite &&
        css`
          fill: ${buildColor("yellow", "400")};
          stroke: ${buildColor("yellow", "400")};
        `}
    }
  }
`;

export const TextContainer = styled.div`
  display: flex;
  width: 0;
  cursor: pointer;

  div[data-qa-label="favorite-button-text"] {
    line-height: 1;
    flex-shrink: 0;
  }
`;
